import * as Oazapfts from "oazapfts/lib/runtime";
import {computed} from "vue";
import useServer from "src/composables/server/useServer";
import * as formeAPI from "src/generated/formeapi";
import {
  CntJournalListResponse,
  DashboardResponse,
  GenericResponse,
  JournalListResponse,
  LicenseRegisterRequest,
  LicenseVerifyRequest,
  PastDashboardResponse,
  StatusReportListResponse, SurveyListRequest,
  UserListResponse,
  UserRequest,
  UserVerifyResponse
} from "src/generated/formeapi";
import {handle} from "oazapfts";
import cookie from "js-cookie";

export default function useFormeServer() {
  const {baseUrl, manageToken} = useServer("admin");

  const requestOptions = computed((): Oazapfts.RequestOpts => {
    const jwt = cookie.get("_at");

    return {
      baseUrl: baseUrl.value,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    };
  });

  async function v2ResourcesListUser(
    xClientModel: string
  ): Promise<UserListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesListUser(xClientModel, requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2LicenseVerify(
    licenseVerifyRequest: LicenseVerifyRequest
  ): Promise<GenericResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2LicenseVerify(licenseVerifyRequest, requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesCreateUser(
    userRequest: UserRequest
  ): Promise<UserListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesCreateUser(userRequest, {}, requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2LicenseRegister(
    licenseRegisterRequest: LicenseRegisterRequest
  ): Promise<GenericResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2LicenseRegister(
          licenseRegisterRequest,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesRetrieveUserDashboard(
    userUuid: string
  ): Promise<DashboardResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesRetrieveUserDashboard(
          userUuid,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesListJournal(
    appuserUuid?: string | null
  ): Promise<JournalListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesListJournal(
          {itemsPerGroup: 1000, appuserUuid},
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesPartialUpdateUser(
    userRequest: UserRequest
  ): Promise<UserListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesPartialUpdateUser(
          userRequest,
          {},
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesUserWithdrawal(): Promise<
    GenericResponse | string
  > {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesUserWithdrawal(requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesDeleteUser(
    userUuid: string
  ): Promise<GenericResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesDeleteUser(userUuid, requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesRetrievePastDashboard(
    userUuid: string
  ): Promise<PastDashboardResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesRetrievePastDashboard(
          userUuid,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesApplySurvey(
    surveyListRequest: SurveyListRequest
  ): Promise<GenericResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesApplySurvey(
          surveyListRequest,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesUserVerify(
    userRequest: UserRequest
  ): Promise<UserVerifyResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesUserVerify(userRequest, requestOptions.value),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesListUserStatusReport(
    userUuid: string
  ): Promise<StatusReportListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesListUserStatusReport(
          userUuid,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesListCntJournal(
    appuserUuid?: string | null,
    itemsPerGroup?: number | null,
    xClientVersion?: string,
    xClientOs?: string,
  ):
    Promise<CntJournalListResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesListCntJournal(
          {xClientVersion, xClientOs, itemsPerGroup, appuserUuid},
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  async function v2ResourcesRetrievePastCntDashboard(
    userUuid: string,
  ):
    Promise<PastDashboardResponse | string> {
    try {
      await manageToken();

      return await handle(
        formeAPI.v2ResourcesRetrievePastCntDashboard(
          userUuid,
          requestOptions.value
        ),
        {
          200(res) {
            return res;
          },
          418(genericResponse) {
            return genericResponse.code + " | " + genericResponse.message;
          },
          common(status: number, data: any) {
            return JSON.stringify(data);
          },
        }
      );
    } catch (e) {
      return e + "";
    }
  }

  return {
    v2ResourcesListUser,
    v2LicenseVerify,
    v2ResourcesCreateUser,
    v2LicenseRegister,
    v2ResourcesRetrieveUserDashboard,
    v2ResourcesListJournal,
    v2ResourcesPartialUpdateUser,
    v2ResourcesUserWithdrawal,
    v2ResourcesDeleteUser,
    v2ResourcesRetrievePastDashboard,
    v2ResourcesApplySurvey,
    v2ResourcesUserVerify,
    v2ResourcesListUserStatusReport,
    v2ResourcesListCntJournal,
    v2ResourcesRetrievePastCntDashboard
  };
}
